import React from 'react';
import OnboardingCarousel, { Spotlight } from './OnboardingCarousel';

// Shown once, the first time a user lands on the Chores tab with a household —
// right after joining/creating one. Points/formula was already covered in
// WelcomeCarousel, so this one is about the screen itself: logging, folders,
// the scoreboard.
const TourCarousel = ({ onDone, onSkip }) => {
  const slides = [
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <p className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest mb-5">Tap to log it</p>
          <Spotlight>
            <div className="w-full bg-ink-card border border-white/10 rounded-2xl p-3.5 flex items-center gap-3">
              <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: 'oklch(0.72 0.155 48)' }} />
              <div className="flex-1 text-left min-w-0">
                <p className="text-sm font-medium text-ink-fg/90 truncate">Take out trash</p>
                <p className="text-[10px] font-mono text-ink-fg/35 mt-0.5">last: today</p>
              </div>
              <span className="text-[10px] font-mono font-semibold text-ink-fg/40 flex-shrink-0">1 PTS</span>
            </div>
          </Spotlight>
          <p className="text-sm text-ink-fg/55 mt-5 leading-relaxed max-w-[260px]">
            Tap any chore to log that you did it — pick the time, difficulty, and who helped.
          </p>
        </div>
      ),
    },
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <p className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest mb-5">Grouped into folders</p>
          <Spotlight>
            <div className="w-full bg-ink-card2 rounded-lg px-3 py-2.5 flex items-center justify-between text-left">
              <span className="text-xs font-mono font-medium text-ink-fg/70 uppercase tracking-wider">Kitchen</span>
              <span className="text-[10.5px] font-mono text-ink-fg/35">3 chores · 38 pts</span>
            </div>
          </Spotlight>
          <p className="text-sm text-ink-fg/55 mt-5 leading-relaxed max-w-[260px]">
            Chores group by room or category — tap a folder to open it, drag to reorder.
          </p>
        </div>
      ),
    },
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <p className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest mb-5">The scoreboard</p>
          <Spotlight>
            <div className="w-full bg-ink-card border border-white/10 rounded-2xl p-3">
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest">7 Days</span>
                <div className="flex items-center gap-2.5">
                  <span className="w-1.5 h-1.5 rounded-sm" style={{ backgroundColor: 'oklch(0.72 0.155 48)' }} />
                  <span className="text-[10.5px] font-mono font-medium text-ink-fg/75">18</span>
                  <span className="w-1.5 h-1.5 rounded-sm" style={{ backgroundColor: 'oklch(0.68 0.145 242)' }} />
                  <span className="text-[10.5px] font-mono font-medium text-ink-fg/75">12</span>
                </div>
              </div>
              <div className="flex h-1.5 rounded-full overflow-hidden mt-2.5 gap-0.5">
                <div className="flex-[3]" style={{ backgroundColor: 'oklch(0.72 0.155 48)' }} />
                <div className="flex-[2]" style={{ backgroundColor: 'oklch(0.68 0.145 242)' }} />
              </div>
            </div>
          </Spotlight>
          <p className="text-sm text-ink-fg/55 mt-5 leading-relaxed max-w-[260px]">
            See how the household's split over the last week, right under the banner.
          </p>
        </div>
      ),
      cta: 'Got it',
    },
  ];

  return <OnboardingCarousel slides={slides} onDone={onDone} onSkip={onSkip} />;
};

export default TourCarousel;
